import React, { useState, useEffect } from 'react';
import ServerList from './components/ServerList';
import ServerDetail from './components/ServerDetail';
import './App.css';

function App() {
  const [currentView, setCurrentView] = useState('list');
  const [serverId, setServerId] = useState(null);

  useEffect(() => {
    // Handle initial URL
    checkCurrentRoute();
    
    // Handle browser navigation
    const handlePopState = () => {
      checkCurrentRoute();
    };
    
    // Handle programmatic navigation
    const handleRouteChange = () => {
      checkCurrentRoute();
    };
    
    window.addEventListener('popstate', handlePopState);
    window.addEventListener('routechange', handleRouteChange);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('routechange', handleRouteChange);
    };
  }, []);

  const checkCurrentRoute = () => {
    const path = window.location.pathname;
    
    if (path === '/' || path.startsWith('/tag/')) {
      setCurrentView('list');
      setServerId(null);
    } else {
      // Check if it's a server ID route (alphanumeric IDs)
      const serverIdMatch = path.match(/^\/([a-zA-Z0-9]+)$/);
      if (serverIdMatch) {
        setCurrentView('detail');
        setServerId(serverIdMatch[1]);
      } else {
        setCurrentView('list');
        setServerId(null);
      }
    }
  };

  if (currentView === 'detail' && serverId) {
    return <ServerDetail serverId={serverId} />;
  }

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-content">
          <h1>Server list</h1>
        </div>
      </header>
      <main className="main-content">
        <ServerList />
      </main>
    </div>
  );
}

export default App;